module.exports = __webpack_public_path__ + "img/bankkartcombo.4db85084.png";